<template>
  <!-- 搜索频率分析 -->
  <div class="searchFrequency">
    <!-- 面包屑导航 -->
    <crumbs-bar
      @refresh="handleRefresh"
      :crumbsList="['用户分析', $route.meta.title]"
    >
      <template slot="controls">
        <el-button type="primary" icon="el-icon-download" @click="exportData"
          >导出数据</el-button
        >
      </template>
    </crumbs-bar>
    <!-- 搜索框 -->
    <search-bar>
      <template>
        <label class="label">日期范围：</label>
        <el-select
          placeholder="日期范围"
          style="width: 100px; margin-right: 5px"
          v-model="searchForm.type"
        >
          <el-option label="全部数据" value="0"></el-option>
          <el-option label="自定义" value="9"></el-option>
          <el-option label="今天" value="1"></el-option>
          <el-option label="昨天" value="2"></el-option>
          <el-option label="近7天" value="3"></el-option>
          <el-option label="近30天" value="4"></el-option>
          <el-option label="本月" value="5"></el-option>
          <el-option label="本季度" value="6"></el-option>
          <el-option label="半年" value="7"></el-option>
          <el-option label="本年" value="8"></el-option>
        </el-select>
        <el-date-picker
          v-model="searchForm.start"
          style="margin-right: 5px"
          type="date"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          v-show="searchForm.type == 9"
          clearable
          placeholder="选择开始日期"
        >
        </el-date-picker>
        <el-date-picker
          v-model="searchForm.end"
          style="margin-right: 5px"
          type="date"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          v-show="searchForm.type == 9"
          clearable
          placeholder="选择截至日期"
        >
        </el-date-picker>
        <el-input
          style="width: 200px; margin-right: 5px"
          clearable
          placeholder="输入关键字"
          v-model="searchForm.name"
        ></el-input>
        <el-button type="primary" icon="el-icon-search" @click="getTableData(1)"
          >搜索</el-button
        >
      </template>
    </search-bar>
    <!-- 数据展示 -->
    <el-table
      :data="tableData"
      stripe
      border
      height="calc(100% - 130px)"
      tooltip-effect="dark"
      style="width: 100%"
    >
      <el-table-column label="序号" align="center" width="50">
        <template slot-scope="scope">
          <span>{{ (currPage - 1) * pageSize + scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="number"
        align="center"
        show-overflow-tooltip
        width="300"
        label="搜索热度(次数)"
      >
        <template slot-scope="scope">
          <el-tag type="danger" effect="dark">{{ scope.row.number }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="keywords"
        label="搜索词"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination
      :allPage="allPage"
      :pageSize="pageSize"
      :currIndex="currPage"
      @hanSiChange="hanSiChange"
      @hanCurrChange="hanCurrChange"
    ></pagination>
  </div>
</template>

<script>
export default {
  name: "searchFrequency",
  data() {
    return {
      /**表格数据 */
      // {
      //   number: '', // 数量
      //   keywords: '' // 关键词
      // }
      tableData: [],
      /**搜索表单 */
      searchForm: {
        start: "",
        type: "0",
        end: "",
        name: "",
      },
      /**分页数据 */
      currPage: 1,
      pageSize: 20,
      allPage: 0,
    };
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    /**获取表格数据 */
    getTableData(num) {
      this.currPage = num == 1 ? 1 : this.currPage;
      let data = {
        type: "GoodsSearch",
        startDate: this.searchForm.start,
        endDate: this.searchForm.end,
        strWhere: this.searchForm.name,
        datetype: this.searchForm.type || "0",
        PageIndex: this.currPage,
        PageSize: this.pageSize,
      };
      let proc = "Proc_Admin_Statistical"; // 存储过程名
      let type = "ReturnList";
      this.$requestSys({
        method: "post",
        url:
          "goods/ashx/ReturnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
      })
        .then((res) => {
          this.tableData = [];
          if (res.flag == 0) {
            this.allPage = res.recordCount;
            this.tableData = res.data.map((item) => ({
              number: item.Num,
              keywords: item.SearchValue,
            }));
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    /**刷新数据 */
    handleRefresh() {
      this.getTableData();
    },
    /**分页size改变 */
    hanSiChange(val) {
      this.pageSize = val;
      this.getTableData();
    },
    /**当前页改变 */
    hanCurrChange(val) {
      this.currPage = val;
      this.getTableData();
    },
    // 导出数据
    exportData() {
      let data = {
        type: "GoodsSearch",
        userId: window.localStorage.getItem("userId"),
        entId: window.localStorage.getItem("entId"),
        startDate: this.searchForm.start,
        endDate: this.searchForm.end,
        strWhere: this.searchForm.name,
        datetype: this.searchForm.type || "0",
        PageIndex: 1,
        PageSize: 9999999,
      };
      let proc = "Proc_Admin_Statistical";
      window.location.href =
        this.baseUrl +
        "Order/NoPIGExprot?json=" +
        encodeURIComponent(JSON.stringify(data)) +
        "&proc=" +
        encodeURIComponent(proc) +
        "&name=搜索频率";
    },
  },
};
</script>

<style scoped>
.searchFrequency {
  width: 100%;
  height: 100%;
}
</style>
